<script lang="ts">
    import { onDestroy, setContext } from 'svelte'
    import { derived as sderived, writable } from 'svelte/store'
    import type { Writable } from 'svelte/store'

    import { Router, type RouteConfig } from '@mateothegreat/svelte5-router'

    import { spath } from 'hydria/svelte_helpers'

    import { UserHandler } from './user'

    import CustomEmail from './CustomEmail.svelte'
    import ExtraMeta from './ExtraMeta.svelte'
    import ImportDomain from './ImportDomain.svelte'
    import ImportDomainContacts from './ImportDomainContacts.svelte'
    import User from './User.svelte'

    interface Props {
        route: any
    }

    let { route = {} }: Props = $props()

    const unsubs: any[] = []
    onDestroy(() => {
        for (const unsub of unsubs) unsub.unsubscribe != null ? unsub.unsubscribe() : unsub()
    })

    const userId: Writable<string> = writable(route.result.path.params?.id)

    const user = new UserHandler()

    $effect(() => {
        $userId = route.result.path.params?.id
        user.reset(route.result.path.params?.id)
    })

    setContext(
        'userId',
        sderived(userId, ($userId) => $userId),
    )
    setContext('User', user)

    const routes: RouteConfig[] = [
        { path: '/', component: User },
        { path: '/custom-email', component: CustomEmail },
        { path: '/extra-meta', component: ExtraMeta },
        { path: '/import', component: ImportDomain },
        { path: /^\/import\/(?<system>[a-z]+)\/(?<domainIdna>[^/]+)$/, component: ImportDomainContacts },
    ]
</script>

<Router {routes} basePath={spath(`/wdom-user/${$userId}`)} />
